import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { DaftarPenilaianPeriodikKs } from 'app/KinerjaDinasPage/pages/periodik/DaftarPenilaianPeriodikKs'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaDinasEnabled = toggle?.['kinerja-dinas-enabled'] || false
    const isKinerjaPenilaianPeriodikEnabled =
      toggle?.['kinerja-penilaian-periodik-enabled'] || false

    if (
      !isKinerjaEnabled ||
      !isKinerjaDinasEnabled ||
      !isKinerjaPenilaianPeriodikEnabled
    ) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

export default function Page() {
  return (
    <PageGuardDinas>
      <DaftarPenilaianPeriodikKs />
    </PageGuardDinas>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  className: '!max-w-full min-h-screen',
  forceResolution: true,
}
